"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentBracketMatchGameStatus = void 0;
var TournamentBracketMatchGameStatus;
(function (TournamentBracketMatchGameStatus) {
    TournamentBracketMatchGameStatus[TournamentBracketMatchGameStatus["Locked"] = 0] = "Locked";
    /** One participant is ready and waiting for the other one. */
    TournamentBracketMatchGameStatus[TournamentBracketMatchGameStatus["Waiting"] = 1] = "Waiting";
    /** Both participants are ready to start. */
    TournamentBracketMatchGameStatus[TournamentBracketMatchGameStatus["Ready"] = 2] = "Ready";
    /** The match is running. */
    TournamentBracketMatchGameStatus[TournamentBracketMatchGameStatus["Running"] = 3] = "Running";
    /** The match is completed. */
    TournamentBracketMatchGameStatus[TournamentBracketMatchGameStatus["Completed"] = 4] = "Completed";
    /** At least one participant completed his following match. */
    TournamentBracketMatchGameStatus[TournamentBracketMatchGameStatus["Archived"] = 5] = "Archived";
})(TournamentBracketMatchGameStatus = exports.TournamentBracketMatchGameStatus || (exports.TournamentBracketMatchGameStatus = {}));
//# sourceMappingURL=tournament-bracket-match-game-status.js.map